import { DepositAndLossLimitSubmit, LimitIncreaseConsent } from "@data-types";

export function buildLimitIncreaseConsents(
	formData: DepositAndLossLimitSubmit,
	t: (key: string) => string
): LimitIncreaseConsent[] {
	return [
		{
			consentContent: t("my-limits:LIMIT_INCREASE_CONSENT_GDPR"),
			hasConsented: formData.consentGdpr === true,
		},
		{
			consentContent: t("my-limits:LIMIT_INCREASE_CONSENT_GGL"),
			hasConsented: formData.consentGgl === true,
		},
		{
			consentContent: t("my-limits:LIMIT_INCREASE_CONSENT_CREDIT_CHECK"),
			hasConsented: formData.consentCreditCheck === true,
		},
	].filter((consent) => consent.hasConsented);
}
